import * as React from 'react';
export const arrowsLoopSvg = React.forwardRef(function arrowsLoopSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.22 4.862a.65.65 0 0 0 .96.876l2.1-2.3a.65.65 0 0 0 0-.876l-2.1-2.3a.65.65 0 1 0-.96.876L8.281 2.3h-5.08A2.7 2.7 0 0 0 .5 5v.3a.7.7 0 1 0 1.4 0V5a1.3 1.3 0 0 1 1.3-1.3h5.08L7.22 4.862ZM11.5 6.7a.7.7 0 1 0-1.4 0V7a1.3 1.3 0 0 1-1.3 1.3H3.719l1.06-1.161a.65.65 0 0 0-.96-.877l-2.1 2.3a.65.65 0 0 0 0 .876l2.1 2.3a.65.65 0 1 0 .96-.876L3.72 9.701H8.8A2.7 2.7 0 0 0 11.5 7v-.3Z',
    }),
  );
});
arrowsLoopSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowsLoop = {
  category: 'icon',
  colorable: true,
  name: 'arrowsLoop',
  svg: arrowsLoopSvg,
};
